import {EventEmitter, Injectable, InjectionToken, signal} from '@angular/core';

export const NOTIFICATION_SETTINGS_URL_TOKEN = new InjectionToken<string>('NotificationSettingsUrlToken');
export const DEFAULT_NOTIFICATION_SETTINGS_URL = '/portal/profile/subscriptions';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  showSettings = signal(true);
  disableLinks = signal(false);
  onMarkAsRead = new EventEmitter<number[]>();
}
